import styled from 'styled-components';

const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;
`;

export const Toolbar = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 1rem;
  margin-bottom: 24px;

  label {
    font-size: 14px;
    color: #0E2244;
    font-weight: 500;
  }

  input {
    padding: 8px 12px;
    border: 1px solid #ccc;
    border-radius: 8px;
    font-size: 14px;
    outline: none;
    transition: border-color 0.2s;

    &:focus {
      border-color: #0E2244;
    }
  }

  @media screen and (max-width: 760px) {
    flex-direction: column;
    gap: 0.5rem;
  }
`;

const Label = styled.label`
  display: block;
  font-weight: bold;
  margin-bottom: 0.5rem;
  color: #333;
`;

const AddCardButton = styled.button`
  background-color: #0E2244;
  color: white;
  padding: 8px 16px;
  border: none;
  height: 48px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
  margin-bottom: 16px;
  flex: 0 0 auto;
  white-space: nowrap;

  &:hover {
    background-color: #081833;
  }
  @media screen and (max-width: 760px) {
    width: 100%;
  }
`;

const Card = styled.div`
  display: flex;
  background-color: #fff;
  border-radius: 12px;
  height: 120px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

interface ImageProps {
  $isPlaceholder?: boolean;
}

const OptionContent = styled.div`
  display: flex;
  flex-direction: column;
  font-family: Poppins;
  font-size: 14px;
  padding: 8px;
  max-width: 500px;

  span.id {
    font-weight: bold;
    color: #0E2244;
  }

  span.local {
    color: #666;
    font-size: 13px;
  }

  span.desc {
    color: #444;
    font-size: 12px;
    margin-top: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const Image = styled.img<ImageProps>`
  width: 160px;
  height: 120px;
  object-fit: ${({ $isPlaceholder }) => ($isPlaceholder ? "contain" : "cover")};
  border-radius: 8px;
  padding:  ${({ $isPlaceholder }) => ($isPlaceholder ? "5px" : "0")};
  background: ${({ $isPlaceholder }) => ($isPlaceholder ? "#d2d2d2" : "none")};
`;

const CardInfo = styled.div`
  padding: 16px;
  flex: 1;
`;

const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  h2 {
    font-size: 16px;
    margin: 0;
    color: #333;
  }
`;

const DeleteIcon = styled.button`
  background: none;
  border: none;
  color: #c00;
  font-size: 16px;
  cursor: pointer;

  &:hover {
    color: #900;
  }
`;

export {
  ListWrapper,
  AddCardButton,
  OptionContent,
  Card,
  Image,
  CardInfo,
  Label,
  CardHeader,
  DeleteIcon,
};
